import axios from "axios";
const apiRequest = axios.create({
    baseURL: "https://w2porn.fun/v0/api",
    withCredentials: true
})
export default apiRequest;